if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

        FoxTheme.Motion.inView(this.closest('.countdown__wrapper'), async () => {
          this.setupConstants();
          this.initSelectors();

          this.fetchDomElements();
          this.shouldAddLeadingZero = true;
          this.loop = false;
          this.onComplete = () => {};

          this.startCountdownUntilMidnight();
        });
      }

      setupConstants() {
        this.MILLISECONDS = {
          DAY: 24 * 60 * 60 * 1000,
          HOUR: 60 * 60 * 1000,
          MINUTE: 60 * 1000,
          SECOND: 1000,
        };
        this.intervalDuration = 1000;

        // Set end date: May 4 (local time)
        this.endDate = new Date('2025-12-01T23:59:59'); // or adjust to UTC if needed
      }

      initSelectors() {
        this.selectorMapping = {
          day: '[data-timer-day]',
          hour: '[data-timer-hour]',
          minute: '[data-timer-minute]',
          second: '[data-timer-second]',
        };
        this.units = ['day', 'hour', 'minute', 'second'];
      }

      fetchDomElements() {
        this.elements = {};
        this.units.forEach((unit) => {
          this.elements[unit] = this.querySelector(this.selectorMapping[unit]);
        });
      }

      startCountdownUntilMidnight() {
        const now = new Date();

        if (now > this.endDate) {
          this.terminateCountdown(true); // Hide if after May 4
          return;
        }

        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0); // Midnight tonight

        this.targetTime = midnight.getTime();
        this.beginCountdown();

        // Reset countdown at next midnight
        const msUntilMidnight = this.targetTime - now.getTime();
        this.resetTimeout = setTimeout(() => {
          this.startCountdownUntilMidnight();
        }, msUntilMidnight);
      }

      beginCountdown() {
        clearInterval(this.intervalId);
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();
          if (remainingTime <= 0) {
            this.terminateCountdown(false);
          } else {
            this.updateDisplay(remainingTime);
          }
        }, this.intervalDuration);

        this.classList.remove('hidden');
        this.closest('.pro-countdown')?.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const timeComponents = this.computeTimeComponents(remainingTime);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = this.formatTimeComponent(timeComponents[unit]);
          }
        });
      }

      computeTimeComponents(ms) {
        return {
          day: Math.floor(ms / this.MILLISECONDS.DAY),
          hour: Math.floor((ms % this.MILLISECONDS.DAY) / this.MILLISECONDS.HOUR),
          minute: Math.floor((ms % this.MILLISECONDS.HOUR) / this.MILLISECONDS.MINUTE),
          second: Math.floor((ms % this.MILLISECONDS.MINUTE) / this.MILLISECONDS.SECOND),
        };
      }

      formatTimeComponent(value) {
        return this.shouldAddLeadingZero && value < 10 ? `0${value}` : value.toString();
      }

      terminateCountdown(hide = false) {
        clearInterval(this.intervalId);
        clearTimeout(this.resetTimeout);
        if (hide) {
          this.classList.add('hidden');
          this.closest('.pro-countdown')?.classList.add('hidden');
        } else if (this.loop) {
          this.beginCountdown();
        } else {
          this.onComplete();
        }
      }

      resetCountdown() {
        clearInterval(this.intervalId);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = '00';
          }
        });
      }
    }
  );
}
